export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_review') || '审核',
    icon: 'el-icon-circle-check',
    menuType: 'review',
    allow: 'V',
  },
]
